import NextImage from "../../lib/NextImage";
import BaseOption from "./base-checkbox/BaseOption";

interface Props {
  selected: boolean;
  toggleOption: () => void;
  image_src: string;
  disabled?: boolean;
  is_multi_select: boolean;
  label: string;
  isProductBox?: boolean;
}

const ImageOption: React.FC<Props> = ({
  selected,
  toggleOption,
  image_src,
  label,
  disabled = false,
  is_multi_select,
  isProductBox,
}) => {
  return (
    <div
      onClick={disabled ? () => {} : toggleOption}
      className={`product-add-on ${selected ? "checked" : ""}`}
      style={isProductBox?{
        width: 20,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 1,
        border: "1px solid",
        borderColor: !selected ? "#FFFF" : undefined,
        borderRadius: 10,
      }:undefined}
    >
      <div
        className="add-on-image"
        style={isProductBox?{ width: 16, height: 16, borderRadius: 10 }:undefined}
      >
        <NextImage alt="" src={image_src} objectFit="fill" />
      </div>
      {!isProductBox && (
        <BaseOption
          disabled={disabled}
          selected={selected}
          toggleOption={toggleOption}
          is_multi_select={is_multi_select}
          label={label}
        />
      )}
    </div>
  );
};

export default ImageOption;
